import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./i18n";
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import {store, persistor} from './store'; // Adjust path as necessary
import './styles/custom.scss';
import './index.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import {HelmetProvider} from '@dr.pogodin/react-helmet'; // ✅ Import

// Create a root component that wraps your App
const Root = () => (
    <React.StrictMode>
        <HelmetProvider> {/* ✅ Wrap everything inside HelmetProvider */}
        <Provider store={store}>
            <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
                <App/>
            </PersistGate>
        </Provider>
        </HelmetProvider>
    </React.StrictMode>
);

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
    // Use hydrateRoot for pre-rendered content
    ReactDOM.hydrateRoot(rootElement, <Root/>);
} else {
    // Use createRoot for client-side rendering
    const root = ReactDOM.createRoot(rootElement);
    root.render(<Root/>);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint.
reportWebVitals();
